import type { PortfolioBreakdownItem } from 'venn-api';
import { type PortfolioBreakdownHierarchyNode } from 'venn-components';
import { getRandomId } from 'venn-utils';

/**
 * Recursively build Portfolio Breakdown item hierarchy
 */
const buildPortfolioBreakdownHierarchy = (item: PortfolioBreakdownItem): PortfolioBreakdownHierarchyNode => ({
  id: getRandomId(), // add id since label can have duplicates
  allocation: item.allocation,
  label: item.label,
  weight: item.weight,
  children:
    item.children?.length && !item.fund
      ? item.children.map((child) => buildPortfolioBreakdownHierarchy(child))
      : undefined,
  isFund: Boolean(item.fund),
  fundId: item.fund?.id,
});

export const getPortfolioBreakdownDetails = (items: PortfolioBreakdownItem[]) => {
  return {
    hierarchy: items.map((item) => buildPortfolioBreakdownHierarchy(item)),
  };
};
